var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MainScreen"},[_c('Transition',{attrs:{"name":"main-router","mode":"out-in"}},[_c('RouterView')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }